// src/components/Footer.tsx
import React from "react";
import { useTranslation } from "react-i18next";
const Footer = () => {
    const { t } = useTranslation();
    return (React.createElement("footer", { id: "cooperate", className: "footer" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "footer__inner" },
                React.createElement("h3", { className: "footer__title" }, t("welcomepage.cooperating.title")),
                React.createElement("div", { className: "footer__appeal" }, t("welcomepage.cooperating.writeToUs")),
                React.createElement("a", { className: "support-project__btn btn", href: "mailto:info.thetribeonline@gmail.com" }, t("welcomepage.cooperating.write"))))));
};
export default Footer;
